     $(document).ready(function() {
            $(document).on('click', '.offer_code', function(e) {
                var $this = $(this);
                var copiedText = $this.attr('data-clipboard-text');
                var $copiedStatus = $this.find('.copyStatus');
                   copyToClipboard(copiedText);
              console.log(copiedText);
                // Update copy status text
                $copiedStatus.text('Copied!').fadeIn(200, function() {
                    setTimeout(function() {
                        $copiedStatus.fadeOut(1000);
                    }, 1000); // Fade out after 1 second
                });

               });
                function copyToClipboard(text) {
        var tempTextArea = $('<textarea>');
        tempTextArea.val(text);
        $('body').append(tempTextArea);
        tempTextArea.select();
        document.execCommand('copy');
        tempTextArea.remove()
    }


    // b2b popup
       $(".catalogue_btn").click(function () { 
          $(".popup-overlay").fadeIn(200);
          $("body").addClass("popup--active");	
        });
        
        $(".close-btn, .popup-overlay").click(function (e) {
          if ($(e.target).is(".popup-overlay") || $(e.target).is(".close-btn")) {
              $(".popup-overlay").fadeOut(200);
              $("body").removeClass("popup--active");
          }
        });
       
       
 });



 $(document).ready(function(){
  function initSlickSlider() {
    var $slider = $('.shopify-section.icon-with-text .home_icon_list');

    // Destroy if already initialized
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    var slidesToShow = 4; // default for <1024
    var windowWidth = $(window).width();

    if(windowWidth < 650){
      slidesToShow = 2.5;
    } else if(windowWidth < 768){
      slidesToShow = 3;
    } else if(windowWidth < 1024){
      slidesToShow = 4;
    } else {
      // Larger than 1024, no slider
      return;
    }

    $slider.slick({
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      swipeToSlide: true,      // smooth slide to touched point
      touchThreshold: 5,
      slidesToScroll: 1,
      speed: 300,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2.5
          }
        }
      ]
    });
  }

  // Initialize on load
  initSlickSlider();

  // Re-initialize on window resize
  $(window).resize(function(){
    initSlickSlider();
  });
});